import "./productList.css";
import Product from "../product/Product";
import { products } from "../../data";

const ProductList = () => {
  return (
    <div className="pl" id="project">
      <div className="pl-texts">
        <h1 className="pl-title">Create & Inspire. It's Shauntosh</h1>
        <p className="pl-desc">
          List of projects to be included here. You can see my projects demo by clicking Demo Projects on top.
        </p>
      </div>
      <div className="pl-list">
        {products.map((item) => (
          <Product key={item.id} img={item.img} link={item.link} />
        ))}
      </div>
    </div>
  );
};

export default ProductList;
